import React from 'react';
import { Routes, Route} from 'react-router-dom'
import MembershipPlan from "../views/investor/MembershipPlan";
import CompanyDetails from "../views/investor/companyDetails";
import ProjectTags from "../views/investor/projects-tags";
import GeographyTags from "../views/investor/geography-tags";
import InvestorProfile from "../views/investor/Profile";
import AdditionalInformation from "../views/investor/additionalInformation";
import MainComponent from "../views/investor/main";
import AddProject from "../views/creator/add-project";
import NDAComponent from "../views/common/nda-information";
import ProjectShowInterest from "../views/investor/project-show-inertest";
import InvestorMilestones from "../views/investor/investor-milestones";
import PaymentAgreedAmount from "../views/investor/agreed-amount";
import PaymentEscrowDetails from "../views/investor/escrow-bank-details";
import PaymentBankDetails from "../views/investor/bank-details";
import LayerTwoProjectDetails from "../views/investor/layer-two-project-details";
import Chats from "../views/common/chat";
import MemberShipPayment from "../views/investor/MemberShipPayment";
import MembershipPlanPaymentUSA from "../views/investor/MembershipPlanPaymenUSA";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "../views/common/not-found";
import NotificationCenter from "../views/common/notification-center";
import ProfileSettings from '../views/common/profileSettings';


import PasswordSettings from '../views/common/ChangePassword';

const InvestorRoutes = () => {
  return(
    <Routes>
      <Route  path='investor'   element={<ProtectedRoute />}>
        <Route  path={'membership-plan'}  element={<MembershipPlan/>}/>
        <Route  path={'company-details'}  element={<CompanyDetails/>}/>
        <Route  path={'projects-tags'}  element={<ProjectTags/>}/>
        <Route  path={'geography-tags'}  element={<GeographyTags/>}/>
        <Route  path={'profile'}  element={<InvestorProfile/>}/>
        <Route  path={'settings'} element={<ProfileSettings/>}/>
        <Route  path={'additional-details'}  element={<AdditionalInformation/>}/>
        <Route path={'dashboard'} key={document.location.href} element={<MainComponent/>}/>
        <Route path={'projects'} key={document.location.href} element={<MainComponent/>}/>
        <Route path={'add-project'} element={<AddProject/>}/>
        <Route path={'nda-information-project/:projectId'} element={<NDAComponent/>}/>
        <Route path={'project-show-interest/:projectId'} element={<ProjectShowInterest/>}/>
        <Route path={'project-milestones/:projectId'} element={<InvestorMilestones/>}/>
        <Route path={'payments/amount/:contractId/:projectId'} element={<PaymentAgreedAmount/>}/>
        <Route path={'payments/escrow-bank-details/:contractId'} element={<PaymentEscrowDetails/>}/>
        <Route path={'payments/bank-details/:contractId'} element={<PaymentBankDetails/>}/>
        <Route path={'project-details-ly-2/:projectId'} element={<LayerTwoProjectDetails/>}/>
        <Route path={'chat'} element={<Chats/>}/>
        <Route path={'membership-payment'} element={<MemberShipPayment/>}/>
        <Route path={'membership-plan-payment'} element={<MembershipPlanPaymentUSA/>}/>
        <Route path={'notification-center'} element={<NotificationCenter/>}/>
        <Route path={'password-settings'} element={<PasswordSettings/>}/>
      </Route>
      {/*<Route path="*" element={<NotFound />} />*/}
    </Routes>
  )
}


export default InvestorRoutes;
